import {
    FETCH_DRIVER_BY_ID_REQUEST,
    FETCH_DRIVER_BY_ID_SUCCESS,
    FETCH_DRIVER_BY_ID_FAILURE,

    REGISTER_DRIVER_FOR_USER_REQUEST,
    REGISTER_DRIVER_FOR_USER_SUCCESS,
    REGISTER_DRIVER_FOR_USER_FAILURE,

    REGISTER_VEHICLE_FOR_USER_REQUEST,
    REGISTER_VEHICLE_FOR_USER_SUCCESS,
    REGISTER_VEHICLE_FOR_USER_FAILURE,

    FETCH_RECRUITED_VEHICLES_REQUEST,
    FETCH_RECRUITED_VEHICLES_SUCCESS,
    FETCH_RECRUITED_VEHICLES_FAILURE,
} from "../actions/types";

const initialState = {
    drivers: {},
    recruitedVehicles: [],

    loading: false,
    error: null,

    registeringDriver: false,
    registerDriverError: null,

    registeringVehicle: false,
    registerVehicleError: null,

    fetchingRecruitedVehicles: false,
    recruitedVehiclesError: null,
};

const driverReducer = (
    state = initialState,
    action
) => {
    switch (
        action.type
    ) {

        case FETCH_DRIVER_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_DRIVER_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,

                drivers: {
                    ...state.drivers,

                    [
                        action.payload
                            .driver_id
                    ]:
                        action.payload,
                },
            };

        case FETCH_DRIVER_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

        case REGISTER_DRIVER_FOR_USER_REQUEST:
            return {
                ...state,
                registeringDriver:
                    true,

                registerDriverError:
                    null,
            };

        case REGISTER_DRIVER_FOR_USER_SUCCESS:
            return {
                ...state,

                registeringDriver:
                    false,

                registerDriverError:
                    null,

                drivers: {
                    ...state.drivers,

                    [
                        action.payload
                            .driver_id
                    ]:
                        action.payload,
                },
            };

        case REGISTER_DRIVER_FOR_USER_FAILURE:
            return {
                ...state,

                registeringDriver:
                    false,

                registerDriverError:
                    action.payload,
            };

        case REGISTER_VEHICLE_FOR_USER_REQUEST:
            return {
                ...state,

                registeringVehicle:
                    true,

                registerVehicleError:
                    null,
            };

        case REGISTER_VEHICLE_FOR_USER_SUCCESS:
            return {
                ...state,

                registeringVehicle:
                    false,

                registerVehicleError:
                    null,
            };

        case REGISTER_VEHICLE_FOR_USER_FAILURE:
            return {
                ...state,

                registeringVehicle:
                    false,

                registerVehicleError:
                    action.payload,
            };
        
        
        case FETCH_RECRUITED_VEHICLES_REQUEST:
    return {
        ...state,

        fetchingRecruitedVehicles:
            true,

        recruitedVehiclesError:
            null,
    };

        case FETCH_RECRUITED_VEHICLES_SUCCESS:
            return {
                ...state,

                fetchingRecruitedVehicles:
                    false,

                recruitedVehiclesError:
                    null,

                recruitedVehicles:
                    action.payload.data,
            };

        case FETCH_RECRUITED_VEHICLES_FAILURE:
            return {
                ...state,

                fetchingRecruitedVehicles:
                    false,

                recruitedVehiclesError:
                    action.payload,
            };

        default:
            return state;
    }
};

export default driverReducer;